import script from "./NoticableList.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticableList.vue?vue&type=script&setup=true&lang=js"

import "./NoticableList.vue?vue&type=style&index=0&id=12ca12d7&lang=scss"

const __exports__ = script;

export default __exports__